<template lang="pug">
.post-meta-item(
  :class="classes"
  :title="title"
)
  slot
    span.item-text(
      v-if="text"
    ) {{ text }}
    span.item-icon(
      v-if="icon"
    ) {{ icon }}
</template>

<script>
export default {
  name: 'post-meta-item',
  props: {
    fade: {
      type: Boolean,
      default: false,
    },
    smallCaps: {
      type: Boolean,
      default: false,
    },
    italic: {
      type: Boolean,
      default: false,
    },
    underline: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: null,
    },
    text: {
      type: String,
      default: null,
    },
    icon: {
      type: String,
      default: null,
    },
  },
  computed: {
    classes() {
      return {
        '--delay-fade': this.fade,
        '--small-caps': this.smallCaps,
        '--italic': this.italic,
        '--underline': this.underline,
      }
    },
  },
}
</script>

<style lang="sass">
.post-meta-item
  display: inline-block
  font-size: 1rem
  color: var(--base-color)
  padding: .25rem .5rem
  margin: 0
  border-bottom: 1px solid transparent

  &.--underline
    border-bottom-color: var(--accent-color)

  &.--delay-fade
    transition: opacity .3s

  &.--italics
    font-style: italic
  
  &.--small-caps
    font-variant: all-small-caps

  &:not(.--underline-effect)
    border-radius: .5rem .5rem 0 0
    transition: background-color 0.3s

    &:hover,
    &:focus
      background-color: hsla(var(--accent-color-h), var(--accent-color-s), var(--accent-color-l), .1)
  
  & + .post-meta-item
    margin-left: 1rem

  .item-text + .item-icon 
    margin-left: .5rem
</style>
